import type { CreateSetup, Setup } from '@here/api'
import { Button } from '@here/components'
import {
	createForm,
	getValues,
	reset,
	setValue,
	setValues,
	valiForm,
} from '@modular-forms/solid'
import { userId } from '@state'
import { isEqual } from 'lodash-es'
import { createEffect, onCleanup } from 'solid-js'
import { useService } from 'solid-services'
import { css } from 'styled-system/css'
import { Grid } from 'styled-system/jsx'
import { safeParse } from 'valibot'
import { useCreate } from '../state'
import Computed from './Computed'
import General from './General'
import ImageCropAndOCR from './ImageDetection'
import type { ScanedDetails } from './ImageDetection/scannedDetails'
import Technical from './Technical'
import { CreateSetupSchema } from './createSetupSchema'
import { updateComputedFields } from './updateComputedFields'

export type FormFieldType = ReturnType<
	typeof createForm<CreateSetup | Setup>
>[1]['Field']
export default function Details() {
	const { completeDetailStep, newSetup, setNewSetup, isEditing } =
		useService(useCreate)()
	const [form, { Form, Field: FormField }] = createForm<CreateSetup | Setup>({
		validate: valiForm(CreateSetupSchema),
		initialValues: {
			created_by: userId(),
			id: undefined,
			title: '',
			symbol: '',
			exchange: '',
			description: '',
			pattern_specification: undefined,
			image_macro: '',
			image_pattern: '',
			image_time_stop: '',
			image_trend: '',
			image_trigger: '',
			image_volume_by_price: '',
			first_in_new_trend: false,
			has_primer: false,
			high_1_price: undefined,
			high_1_time: '',
			scan_tool_valid: null,
		},
	})

	createEffect(() => {
		const initialValues = newSetup()

		if (initialValues) {
			setValues(form, initialValues as any)
		} else {
			reset(form)
		}
	})

	onCleanup(() => {
		isEditing() ? setNewSetup(undefined) : setNewSetup(getValues(form) as any)
	})

	createEffect(() => {
		setValue(form, 'created_by', userId() || '')
	})

	// this function calculates the computed fields, and updates the form
	createEffect(() => {
		console.log(getValues(form))
		const formValues = getValues(form)
		const currentFormValue = newSetup()

		if (!isEqual(formValues, currentFormValue) && !form.submitted) {
			const z = safeParse(CreateSetupSchema, getValues(form))
			updateComputedFields(form)
			setNewSetup(formValues as any)
		}
	})

	const onConfirmDetails = (details: ScanedDetails, callback: () => void) => {
		const position = details.high_1_time! < details.low_1_time! ? 'long' : 'short'

		setValues(form, {
			...details,
			scan_tool_valid: true,
			position,
		} as any) // todo type this

		callback()
	}

	return (
		<Grid gap={4}>
			<ImageCropAndOCR onConfirmDetails={onConfirmDetails} />
			{/* <Divider /> */}
			<Form
				class={css({
					display: 'grid',
					gap: '6',
				})}
				onSubmit={(v) => {
					completeDetailStep(v)
				}}
			>
				<General
					FormField={FormField}
					form={form}
				/>
				<Technical
					FormField={FormField}
					form={form}
				/>
				<Computed
					FormField={FormField}
					form={form}
				/>
				<Button type="submit">Confirm Setup</Button>
			</Form>
		</Grid>
	)
}
